import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isCollapse: true,
    list: [],
    initialList: {},
  },
  mutations: {
    setIsCollapse(state, isCollapse) {
      state.isCollapse = isCollapse;
    },
    setList(state, list) {
      state.list = list;
    },
    setInitialList(state, initialList) {
      state.initialList = initialList;
    }
  },
  actions: {},
  modules: {}
});